import { ITemplate } from '../model';
import { TemplateDto } from './template.types';
import { mapTemplateDto } from '../libs';
import { TEMPLATE_TAG, baseApi } from '@shared/api';

export const templateApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getTemplates: build.query<ITemplate[], void>({
      query: () => ({
        url: '/invoices/templates',
      }),
      transformResponse: (response: TemplateDto[]) => {
        return response.map(template => mapTemplateDto(template));
      },
      providesTags: [TEMPLATE_TAG],
    }),
    addTemplate: build.mutation<void, FormData>({
      query: body => ({
        url: '/invoices/templates',
        method: 'POST',
        body,
      }),
      invalidatesTags: [TEMPLATE_TAG],
    }),
    deleteTemplate: build.mutation<void, string>({
      query: id => ({
        url: `invoices/templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TEMPLATE_TAG],
    }),
  }),
});

export const { useAddTemplateMutation, useDeleteTemplateMutation, useGetTemplatesQuery } = templateApi;
